export default __webpack_public_path__ + "media/cloudIcons.d31fd070.png";